module.exports = __webpack_public_path__ + "media/images/icon__matchdayNavigation--pagination--arrow@2x-0e29e902b3604efdfccdbdc6026ce6eb.png";